var _defs, _path, _path2, _path3, _g, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignInLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 310.853,
    height: 80.423,
    viewBox: "0 0 310.853 80.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29235c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29235c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.531,836.9l-31.811-55.05.364-.2a13.318,13.318,0,0,1,6.495-1.733c4.409,0,8.172,2.178,11.184,6.473l13.768,23.752,13.685-23.722c3.033-4.325,6.817-6.5,11.267-6.5a13.208,13.208,0,0,1,6.432,1.733l.364.2-.207.359Z",
    transform: "translate(-148.72 -779.891)",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M547.474,836.429h-.4c-4.642,0-8.217-2.174-10.626-6.461l0-.007a11.456,11.456,0,0,1-1.309-5.471V808.134a15.91,15.91,0,0,0-27.2-11.252,15.393,15.393,0,0,0-4.646,11.252,15.643,15.643,0,0,0,4.647,11.309,15.386,15.386,0,0,0,11.247,4.643h4.763c4.945,0,8.537,2.344,10.979,7.165a11.609,11.609,0,0,1,1.019,4.773v.4H519.179c-9.369,0-17.085-3.935-22.934-11.7a27.683,27.683,0,0,1-5.361-16.6,28.228,28.228,0,0,1,28.3-28.3h1.435a26.748,26.748,0,0,1,3.054.351,17.559,17.559,0,0,1,3.272.7,20.519,20.519,0,0,1,3.018,1.046,31.072,31.072,0,0,1,5.636,3.139l.164.108a32.751,32.751,0,0,1,3.44,2.912,27.4,27.4,0,0,1,8.276,20.036Z",
    transform: "translate(-428.411 -779.824)",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M871.851,860.247h-28.3v-.4c0-4.643,2.174-8.218,6.463-10.625a11.883,11.883,0,0,1,5.534-1.315h16.3A16.056,16.056,0,0,0,887.8,831.95v-.419a28.392,28.392,0,0,1-31.788.065,28.312,28.312,0,0,1-12.459-23.462,28.328,28.328,0,0,1,28.3-28.3h28.3v.4a11.964,11.964,0,0,1-11.94,11.939H871.851a15.229,15.229,0,0,0-11.246,4.7,15.963,15.963,0,0,0-3.977,15.839,16.053,16.053,0,0,0,6.943,9.014,15.377,15.377,0,0,0,8.28,2.293,15.765,15.765,0,0,0,8.342-2.3,16.045,16.045,0,0,0,6.939-9.014,15.381,15.381,0,0,0,.67-4.584,11.326,11.326,0,0,1,2.677-7.547,11.518,11.518,0,0,1,9.264-4.45h.4V831.95a28.327,28.327,0,0,1-28.3,28.3Z",
    transform: "translate(-716.692 -779.824)",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(191.776 0.029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1209.451,829.767a27.987,27.987,0,1,1,19.8,8.149A26.906,26.906,0,0,1,1209.451,829.767Zm31.278-8.206a16.357,16.357,0,0,0-11.478-27.892,16.355,16.355,0,0,0-11.594,27.892,15.949,15.949,0,0,0,11.594,4.763A15.692,15.692,0,0,0,1240.729,821.561Z",
    transform: "translate(-1200.897 -781.73)",
    fill: "#1fc1cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.44,836.511a28.325,28.325,0,1,1,19.97-8.268A27.461,27.461,0,0,1,1227.44,836.511Zm0-55.782a26.677,26.677,0,0,0-19.514,8.031,26.27,26.27,0,0,0-8.031,19.455,27.515,27.515,0,0,0,55.031,0,27.517,27.517,0,0,0-27.486-27.487Zm0,44.19a16.424,16.424,0,0,1-11.876-4.879,16.761,16.761,0,0,1,11.876-28.585,16.732,16.732,0,0,1,0,33.464Zm0-32.655a15.951,15.951,0,0,0-11.308,27.2,15.644,15.644,0,0,0,11.308,4.645,15.325,15.325,0,0,0,11.192-4.645l0,0a15.953,15.953,0,0,0-11.194-27.2Z",
    transform: "translate(-1199.086 -779.92)",
    fill: "#1fc1cb"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1589.337,788.028a28.254,28.254,0,1,0,8.325,20.028A27.326,27.326,0,0,0,1589.337,788.028Zm-4.076,20.028a15.236,15.236,0,0,1-4.7,11.248l0,0a15.327,15.327,0,0,1-11.192,4.644,15.645,15.645,0,0,1-11.308-4.644,15.953,15.953,0,0,1,11.308-27.2,16.058,16.058,0,0,1,15.894,15.953Z",
    transform: "translate(-1286.808 -779.76)",
    fill: "#1fc1cb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInLogo);
export default __webpack_public_path__ + "static/media/sign-in-logo.87809b54.svg";
export { ForwardRef as ReactComponent };